import { InputAdornment, TextField } from '@mui/material';
import RequireIcon from '@mui/icons-material/FiberManualRecord';
import { useStyles } from '@/pages/styles/ResetPass.styles';
import { handler } from './_handlers';

import type { Dispatch, SetStateAction } from 'react';
import type { ClassNameMap } from '@mui/material';

/** Text */
interface RequiredTextParams<T> {
    stateKey: string & keyof T;
    label: string;
    state: T;
    error?: boolean;
    errorHelper?: string;
    dispatch: Dispatch<SetStateAction<T>>;
    disabled: boolean;
    styles: (props?: any) => ClassNameMap<'textInput'>;
    type: 'email' | 'password' | 'text';
    textArea?: boolean;
}

export const RequiredText = <T,>({
    stateKey,
    label,
    state,
    dispatch,
    disabled,
    type,
    error,
    errorHelper,
    textArea,
}: RequiredTextParams<T>) => {
    const classes = useStyles();
    return (
        <TextField
            // id={state[stateKey] || ''}
            label={label}
            variant='outlined'
            className={classes.textInput}
            value={state[stateKey]}
            onChange={handler.text<T>(stateKey, state, dispatch)}
            autoComplete={`new-${type}`}
            type={type}
            fullWidth
            minRows={4}
            multiline={textArea}
            error={error}
            size='medium'
            helperText={errorHelper}
            disabled={disabled}
            InputProps={{
                endAdornment: (
                    <InputAdornment position='end'>
                        <RequireIcon fontSize='inherit' style={{ color: 'red' }} />
                    </InputAdornment>
                ),
            }}
        />
    );
};
